/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { css } from '@emotion/react'
import { connect } from 'react-redux'
import { bool } from 'prop-types'
import InstallIcon from 'gatsby-theme-marketplace-base/src/assets/icons/LC-install.inline.svg'
import PrivateAppsIcon from 'gatsby-theme-marketplace-base/src/assets/icons/private-apps.inline.svg'
import AdminAppsIcon from 'gatsby-theme-marketplace-base/src/assets/icons/admin-apps.inline.svg'
import { navigateToIFrame } from 'gatsby-theme-marketplace-base/src/utils'
import { getMarketplaceSettingsLink } from 'gatsby-theme-marketplace-base/src/utils/products'
import {
  isDevPlatformAdmin,
  isAuthorized,
} from 'gatsby-theme-marketplace-base/src/store/selectors'
import useHydrationContext from 'gatsby-theme-marketplace-base/src/hooks/useHydrationContext'

const AppSectionLinks = ({ isAuthorized, isDevPlatformAdmin }) => {
  const hydrated = useHydrationContext()
  if (!hydrated || !isAuthorized) {
    return null
  }

  const navigateToAppsList = (e, slug) => {
    e.preventDefault()
    navigateToIFrame(e, `/settings/integrations/${slug}`)
  }

  return (
    <ul className="list">
      <li>
        <a
          onClick={(e) => navigateToAppsList(e, 'installed')}
          href={getMarketplaceSettingsLink('installed')}
          alt="Installed Apps"
        >
          <InstallIcon />
          <span>Installed Apps</span>
        </a>
      </li>

      <li>
        <a
          onClick={(e) => navigateToAppsList(e, 'private')}
          href={getMarketplaceSettingsLink('private')}
          alt="Private Apps"
        >
          <PrivateAppsIcon />
          <span>Private Apps</span>
        </a>
      </li>
      {isDevPlatformAdmin && (
        <li>
          <a
            onClick={(e) => navigateToAppsList(e, 'in-review')}
            href={getMarketplaceSettingsLink('in-review')}
            alt="Apps in review"
          >
            <AdminAppsIcon />
            <span
              css={css`
                position: relative;
              `}
            >
              Apps in review{' '}
            </span>
          </a>
        </li>
      )}
    </ul>
  )
}

const mapStateToProps = (state) => ({
  isAuthorized: isAuthorized(state),
  isDevPlatformAdmin: isDevPlatformAdmin(state),
})

AppSectionLinks.propTypes = {
  isAuthorized: bool,
  isDevPlatformAdmin: bool,
}

export default connect(mapStateToProps)(AppSectionLinks)
